import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const LocationSearchBoxWrapper = styled(Flex, {
  position: 'relative',
  width: '65%',
  marginRight: 'auto',
  marginLeft: 'auto',
  '@media (max-width: 744px)': {
    width: '100%',
  },
  '#location-input-container': {
    flexWrap: 'nowrap',
  },
});

export const SelectedLocationWrapper = styled(Flex, {
  gap: '5px',
  fontWeight: 400,
  button: {
    paddingLeft: '5px',
    fontWeight: 400,
  },
  flexWrap: 'nowrap',
  '*': {
    fontSize: '1.2rem !important',
  },
});
